@if (loading) {
  <div class="row">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>
}

<div class="container-fluid accordion-container">
  <div class="container">
    <mat-accordion class="accordion" multi>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header class="container px-0">
          <mat-panel-title>
            <span class="index">1</span>
            {{ "generic.details" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <mat-card class="my-4 card-details">
          <mat-card-header>
            <mat-card-title class="d-flex align-items-center section-title-purple mb-0">
              <mat-icon class="section-icon mr-2">info</mat-icon>
              {{ "generic.details" | translate }}
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="row">
              <div class="col-md-4">
                <strong>{{ "generic.version" | translate }}:</strong> {{ map?.version }}
              </div>
              <div class="col-md-4">
                <strong>{{ "generic.status" | translate }}
                :</strong> {{ ("pages.ckm-simulations.status." + map?.status) | translate }}
              </div>
              <div class="col-md-4">
                <strong>{{ "userNotes.columns.createdAt" | translate }}:</strong> {{ map?.created_at | date:'short' }}
              </div>
            </div>
          </mat-card-content>
        </mat-card>


        <mat-card class="my-4 card-details">
          <mat-card-header>
            <mat-card-title class="d-flex align-items-center section-title-purple mb-0">
              <mat-icon class="section-icon mr-2">palette</mat-icon>
              Map Legend
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <ul class="list-unstyled my-3 ckm-legend-list">
              <li><span class="ckm-legend-swatch ckm-legend-swatch--red">&#9632;</span> <span class="ckm-legend-label">Red boxes:</span> Undesirable and Exogenous
              events (disease
              manifestations, symptoms and external risk factors)
            </li>
            <li><span class="ckm-legend-swatch ckm-legend-swatch--green">&#9632;</span> <span class="ckm-legend-label">Green boxes:</span> Actions/interventions
            (treatments and management strategies)
          </li>
          <li><strong>Arrows:</strong> Causal relationships between elements</li>
          <li><strong>Text on arrows:</strong> Nature and strength of relationships</li>
        </ul>
      </mat-card-content>
    </mat-card>

    <div class="my-4">
      <div id="myDiagramDiv" class="ckm-diagram-frame"></div>
    </div>

  </mat-expansion-panel>
</mat-accordion>
</div>
</div>

<div class="container-fluid accordion-container">
  <div class="container">
    <mat-accordion class="accordion" multi>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header class="container px-0">
          <mat-panel-title>
            <span class="index">2</span>
            {{ "generic.map" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="container">

          <div class="my-4">
            <h4 class="font-weight-bold d-flex align-items-center section-title-purple mb-3">
              <mat-icon class="section-icon mr-2">play_circle</mat-icon>
              {{ "generic.actions" | translate }}
            </h4>
            <div class="table-container-rounded my-3">
            <table mat-table [dataSource]="map?.actions" class="w-100 table-primary">

              <!-- Colonna Name -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> {{ "generic.name" | translate }}</th>
                <td mat-cell *matCellDef="let element"> {{ element.action.name }}</td>
              </ng-container>

              <!-- Colonna Effort -->
              <ng-container matColumnDef="model_effort">
                <th mat-header-cell *matHeaderCellDef> {{ "pages.ckm-simulations.model_effort" | translate }}</th>
                <td mat-cell *matCellDef="let element"> {{ element.model_effort_cost || 'N/A' }}</td>
              </ng-container>

              <!-- Colonna Effort -->
              <ng-container matColumnDef="survey_effort">
                <th mat-header-cell *matHeaderCellDef> {{ "pages.ckm-simulations.survey_effort" | translate }}</th>
                <td mat-cell *matCellDef="let element"> {{ element.survey_effort_cost || 'N/A' }}</td>
              </ng-container>

              <!-- Colonna Effort -->
              <ng-container matColumnDef="effort">
                <th mat-header-cell *matHeaderCellDef> {{ "pages.ckm-simulations.effort" | translate }}</th>
                <td mat-cell *matCellDef="let element"> {{ element.effort_cost }}</td>
              </ng-container>

              <!-- Colonna Details -->
              <ng-container matColumnDef="details">
                <th mat-header-cell *matHeaderCellDef> {{ "generic.details" | translate }}</th>
                <td mat-cell *matCellDef="let element">
                  <button mat-button color="primary" (click)="viewActionDetails(element)">{{ "generic.details" | translate }}</button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="['name', 'survey_effort', 'model_effort', 'effort', 'details']"></tr>
              <tr mat-row *matRowDef="let row; columns: ['name', 'survey_effort', 'model_effort', 'effort', 'details']"></tr>
            </table>
            </div>
          </div>

          <!-- Mat-table per Eventi -->
          <div class="my-4">
            <h4 class="font-weight-bold d-flex align-items-center section-title-purple mb-3">
              <mat-icon class="section-icon mr-2">event</mat-icon>
              {{ "generic.events" | translate }}
            </h4>
            <div class="table-container-rounded my-3">
            <table mat-table [dataSource]="map?.events" class="w-100 table-primary">

              <!-- Colonna Name -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> {{ "generic.name" | translate }}</th>
                <td mat-cell *matCellDef="let element"> {{ element.event.name }}</td>
              </ng-container>

              <!-- Colonna Tipo -->
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef> {{ "generic.type" | translate }}</th>
                <td mat-cell *matCellDef="let element"> {{ element.type }}</td>
              </ng-container>

              <!-- Colonna Desirability -->
              <ng-container matColumnDef="desirability">
                <th mat-header-cell *matHeaderCellDef> {{ "generic.desiderability" | translate }}</th>
                <td mat-cell *matCellDef="let element"> {{ element.desirability }}</td>
              </ng-container>

              <!-- Colonna Probabilità -->
              <ng-container matColumnDef="model_probability">
                <th mat-header-cell *matHeaderCellDef> {{ "pages.ckm-simulations.model_probability" | translate }}</th>
                <td mat-cell *matCellDef="let element"> {{ element.model_probability || 'N/A' }}</td>
              </ng-container>

              <!-- Colonna Probabilità -->
              <ng-container matColumnDef="survey_probability">
                <th mat-header-cell *matHeaderCellDef> {{ "pages.ckm-simulations.survey_probability" | translate }}</th>
                <td mat-cell *matCellDef="let element"> {{ element.survey_probability || 'N/A' }}</td>
              </ng-container>

              <!-- Colonna Probabilità -->
              <ng-container matColumnDef="probability">
                <th mat-header-cell *matHeaderCellDef> {{ "pages.ckm-simulations.probability" | translate }}</th>
                <td mat-cell *matCellDef="let element"> {{ element.probability }}</td>
              </ng-container>

              <!-- Colonna Details -->
              <ng-container matColumnDef="details">
                <th mat-header-cell *matHeaderCellDef> {{ "generic.details" | translate }}</th>
                <td mat-cell *matCellDef="let element">
                  <button mat-button color="primary" (click)="viewEventDetails(element)">{{ "generic.details" | translate }}</button>
                </td>
              </ng-container>

              <tr mat-header-row
              *matHeaderRowDef="['name', 'type', 'desirability', 'survey_probability', 'model_probability' , 'probability', 'details']"></tr>
              <tr mat-row
              *matRowDef="let row; columns: ['name', 'type', 'desirability', 'survey_probability', 'model_probability' , 'probability', 'details']"></tr>
            </table>
            </div>
          </div>

          <!-- Mat-table per Fattori d'impatto -->

          <div class="my-4">
            <h4 class="font-weight-bold d-flex align-items-center section-title-purple mb-3">
              <mat-icon class="section-icon mr-2">device_hub</mat-icon>
              {{ "generic.impact_factors" | translate }}
            </h4>
            <div class="table-container-rounded my-3">
            <table mat-table [dataSource]="map?.impact_factors" class="w-100 table-primary">

              <!-- Colonna Sorgente -->
              <ng-container matColumnDef="source">
                <th mat-header-cell *matHeaderCellDef> {{ "generic.source" | translate }}</th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.impact_factor?.source?.name }}
                </td>
              </ng-container>

              <!-- Colonna Destinazione -->
              <ng-container matColumnDef="target">
                <th mat-header-cell *matHeaderCellDef> {{ "generic.target" | translate }}</th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.impact_factor?.target?.name }}
                </td>
              </ng-container>

              <ng-container matColumnDef="survey_weight">
                <th mat-header-cell *matHeaderCellDef> {{ "pages.ckm-simulations.survey_weight" | translate }}</th>
                <td mat-cell *matCellDef="let element"> {{ element.weight }}</td>
              </ng-container>

              <ng-container matColumnDef="model_weight">
                <th mat-header-cell *matHeaderCellDef> {{ "pages.ckm-simulations.model_weight" | translate }}</th>
                <td mat-cell *matCellDef="let element"> {{ element.weight }}</td>
              </ng-container>

              <!-- Colonna Weight -->
              <ng-container matColumnDef="weight">
                <th mat-header-cell *matHeaderCellDef> {{ "pages.ckm-simulations.weight" | translate }}</th>
                <td mat-cell *matCellDef="let element"> {{ element.weight }}</td>
              </ng-container>

              <!-- Colonna Details -->
              <ng-container matColumnDef="details">
                <th mat-header-cell *matHeaderCellDef> {{ "generic.details" | translate }}</th>
                <td mat-cell *matCellDef="let element">
                  <button mat-button color="primary" (click)="viewImpactFactorDetails(element)">{{ "generic.details" | translate }}</button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="['source', 'target', 'survey_weight', 'model_weight', 'weight', 'details']"></tr>
              <tr mat-row
              *matRowDef="let row; columns: ['source', 'target', 'survey_weight', 'model_weight', 'weight', 'details']"></tr>
            </table>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>

<div class="container-fluid accordion-container">
  <div class="container">
    <mat-accordion class="accordion" multi>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header class="container px-0">
          <mat-panel-title>
            <span class="index">3</span>
            Cognitive Insight Uplink
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="container my-4">
          @if (!map?.survey_id) {
            <div class="col-12 d-flex justify-content-center my-4">
              <button type="button"
                class="btn-custom btn-magic-add btn-magic-play d-flex align-items-center justify-content-center px-5 py-2"
                (click)="addNewSurvey()">
                <mat-icon class="mr-2">play_circle</mat-icon>
                {{ 'routing.title.surveys' | translate}}
              </button>
            </div>
          } @else {
            <app-survey-details-page
              [surveyId]="map?.survey_id"
              [noButtons]="true"
              />
          }
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>

<div class="container-fluid accordion-container">
  <div class="container">
    <mat-accordion class="accordion" multi>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header class="container px-0">
          <mat-panel-title>
            <span class="index">4</span>
            {{ "generic.dashboard" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="container mt-4">
          <div class="row justify-content-center">
            @for (attachment of attachments; track attachment; let i = $index) {
              <div class="col-6 d-flex mt-4">
                <mat-card class="w-100 card-details">
                  <div class="image-wrapper">
                    <img [src]="attachment" class="img-fluid" alt="Attachment Image">
                  </div>
                </mat-card>
              </div>
            }
            @if (!aiAnalysisShowed) {
              <button
                type="button"
                class="btn-custom btn-magic-add btn-magic-wand d-flex align-items-center justify-content-center px-5 py-2 my-4"
                (click)="showAIAnalysis()"
              >
                <mat-icon class="mr-2" aria-hidden="true">auto_fix_high</mat-icon>
                {{ 'modal.modal-ai-analysis.title' | translate }}
              </button>
            }
            @if (aiAnalysisShowed) {
              <mat-card class="card-details w-100">
                <mat-card-content>
                  <h3 class="d-flex align-items-center section-title-purple font-weight-bold">
                    <mat-icon class="section-icon mr-2">psychology</mat-icon>
                    AI Defence Analyst – Operational Insight Summary
                  </h3>
                  <p><strong>Scenario:</strong> Hybrid Threat Escalation with Cyber-Disruption and Logistical Strain</p>
                  <hr>
                    <h4>Dashboard Interpretation</h4>
                    <p>The dashboard indicates critical instability across three primary clusters:</p>
                    <ol>
                      <li>
                        <strong>Cyber & Electronic Disruption Risk</strong>
                        <ul>
                          <li>High event probability for Electronic Warfare Activities, Cyberattacks, and resulting Communications Failure.</li>
                          <li>The Pareto front identifies these as high-impact but moderately controllable variables.</li>
                        </ul>
                      </li>
                      <li>
                        <strong>Troop & Readiness Vulnerability</strong>
                        <ul>
                          <li>Unit Readiness Status and Force Availability are not aligned with current Troop Deployment trends, creating strategic strain.</li>
                          <li>Optimization plots suggest misalignment between desired force posture and supply capability.</li>
                        </ul>
                      </li>
                      <li>
                        <strong>Logistical Cascade Risks</strong>
                        <ul>
                          <li>Risk of Pipeline Disruption and Fuel Resupply delays strongly correlates with Medical Evacuation bottlenecks.</li>
                          <li>Radar chart shows that resupply and communication systems are suboptimal under simulated stress.</li>
                        </ul>
                      </li>
                    </ol>
                    <h4>Strategic Notes from AI Analyst Module</h4>
                    <ul>
                      <li>A Multi-Domain Coordination Node should be activated to synchronize logistics, ISR and cyberdefence in the southern quadrant.</li>
                      <li>Maintain communications uptime above 90% to reduce disinformation propagation and protect medical extraction routes.</li>
                      <li>Action efficiency is currently under 65%. Redundancy planning and adaptive tasking are recommended within 48h.</li>
                    </ul>
                  </mat-card-content>
                </mat-card>
              }
            </div>
          </div>

          <!--        <mat-card class="container my-5">-->
          <!--          <mat-card-content>-->
          <!--            <h2 class="mb-4">AI Analysis – CBRN Scenario: Optimization & Operational Insight</h2>-->
          <!--            <p>-->
          <!--              This simulation goes beyond traditional <strong>NATO CBRN standard procedures</strong> by leveraging AI to-->
          <!--              analyze multiple strategic responses across operational, logistical, and communicative dimensions.-->
          <!--              The Pareto chart highlights strategies that achieve the <strong>best balance between effectiveness and-->
        <!--              operational feasibility</strong>.-->
      <!--            </p>-->
      <!--            <p>-->
      <!--              Cross-chart reading shows a strong insight: the best-performing strategies lower <strong>exposure risk and-->
    <!--              escalation probability</strong> without compromising speed or clarity of action.-->
    <!--              The AI identifies one <strong>optimal course of action</strong>, offering <strong>incident control,-->
  <!--              resource agility, and structured crisis communication</strong>.-->
<!--            </p>-->
<!--            <h4>Recommended actions:</h4>-->
<!--            <ul>-->
<!--              <li>Deploy remote NBC units for immediate situational assessment</li>-->
<!--              <li>Activate targeted evacuation corridors</li>-->
<!--              <li>Disseminate a layered crisis communication protocol:</li>-->
<!--            </ul>-->
<!--            <div class="border rounded p-3 bg-light">-->
<!--              <p>“The event is under control. Specialist teams are already deployed.”</p>-->
<!--              <p>“Targeted evacuations underway. Follow official instructions only.”</p>-->
<!--              <p>“All operations follow <strong>NATO CBRN emergency standards</strong>, with civilian safety as top-->
<!--                priority.”</p>-->
<!--            </div>-->
<!--          </mat-card-content>-->
<!--        </mat-card>-->


</mat-expansion-panel>
</mat-accordion>
</div>
</div>

<div class="container-fluid accordion-container">
  <div class="container">
    <mat-accordion class="accordion" multi>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header class="container px-0">
          <mat-panel-title>
            <span class="index">5</span>
            Action Plan Management
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="container my-4">
          <div class="table-container-rounded">
          <table mat-table [dataSource]="dataSource" class="w-100 table-primary">

            <!-- Responsive Action -->
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef> Responsive Action </th>
              <td mat-cell *matCellDef="let element"> {{element.action}} </td>
            </ng-container>

            <!-- Responsible -->
            <ng-container matColumnDef="responsible">
              <th mat-header-cell *matHeaderCellDef> Responsible </th>
              <td mat-cell *matCellDef="let element"> {{element.responsible}} </td>
            </ng-container>

            <!-- Start Date -->
            <ng-container matColumnDef="startDate">
              <th mat-header-cell *matHeaderCellDef> Start Date </th>
              <td mat-cell *matCellDef="let element"> {{element.startDate}} </td>
            </ng-container>

            <!-- End Date -->
            <ng-container matColumnDef="endDate">
              <th mat-header-cell *matHeaderCellDef> End Date </th>
              <td mat-cell *matCellDef="let element"> {{element.endDate}} </td>
            </ng-container>

            <!-- Progress -->
            <!-- Progress -->
            <ng-container matColumnDef="progress">
              <th mat-header-cell *matHeaderCellDef> Progress </th>
              <td mat-cell *matCellDef="let element">
                <div class="ckm-action-plan-progress">
                  <mat-progress-bar
                    class="ckm-action-plan-progress-bar"
                    mode="determinate"
                    [value]="element.progress"
                    color="primary"
                  ></mat-progress-bar>
                  <span class="ckm-action-plan-progress-label">{{ element.progress }}%</span>
                </div>
              </td>
            </ng-container>


            <!-- AI Suggestion -->
            <ng-container matColumnDef="aiSuggestion">
              <th mat-header-cell *matHeaderCellDef> AI Suggestion </th>
              <td mat-cell *matCellDef="let element">
                <span class="ckm-ai-suggestion-badge my-2" [class.ckm-ai-suggestion-badge--low]="element.progress < 70" [class.ckm-ai-suggestion-badge--ok]="element.progress >= 70">
                  {{element.aiSuggestion}}
                </span>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          </div>
        </div>


      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>

<div class="buttons-container container py-4">
  <button mat-stroked-button class="ckm-back-link float-left d-flex align-items-center" [routerLink]="['/ckm-simulations/' + map?.ckm_simulation_id]"
    routerLinkActive="router-link-active">
    <mat-icon class="mr-1">arrow_back</mat-icon>
    {{ 'generic.buttons.go-to-simulation' | translate }}
  </button>
</div>
